<template>
  <div>
    <div class="stay-position"></div>
    <div class="send-comment" v-if="localActive">
      <div class="shadow-box" @click="handleClose"></div>
      <div class="content-box">
        <div class="content-input-box">
          <van-field
            class="content-input"
            type="textarea"
            autosize
            rows="1"
            autofocus
            v-model="form.Content"
            :maxlength="maxlength"
            :placeholder="placeHolder"
          />
          <div class="comment-img-list">
            <div class="comment-img" v-for="(img, index) in form.ImgList" :key="index" @click="deleteCommentImg(img)">
              <img :src="img" />
              <span class="delete-comment-img-btn">
                <i class="iconfont icon-quxiao"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="control-box row-flex w">
        <div class="max-length row-flex-eq">
          <upLoad v-if="clearUploadList" @resultUrlList="handleUpImg">
            <i slot="input" class="iconfont upload-btn icon-tupian" />
          </upLoad>
        </div>
        <div class="more">
          <span class="text-gray max-count">{{`${form.Content.length}/${maxlength}`}}</span>
          <van-button size="small" type="primary" @click="submit">发送</van-button>
        </div>
      </div>
    </div>

    <div class="send-comment-bar row-flex w" v-else>
      <div class="show-comment-btn row-flex-eq" @click="handleOpenComment">说点什么...</div>
      <div class="control-box row-flex-between">
        <badge :count="commentsCount">
          <!-- <i class="iconfont icon-pinglun icon-btn" @click="goComment"></i> -->
          <span class="" @click="goComment">评论</span>
        </badge>
        <goodBtn
          class="icon-btn"
          v-model="isGood"
          :showCount="false"
          :sourceId="info.SourceId"
          @onSuccess="handleGoodSuccess"
        />
        <favBtn v-model="info.isFav"  :sourceId="info.SourceId" />
      </div>
    </div>
  </div>
</template>
<script>
import goodBtn from "@/components/article/goodBtn.vue";
import upLoad from "@/components/common/upLoad.vue";
import EventBus from "@/services/bus";
import badge from "@/components/common/badge.vue";
import { Comment } from "@/api";
import favBtn from "@/components/article/favBtn.vue";
export default {
  name: "sendCommentBar",
  components: {
    goodBtn,
    upLoad,
    badge,
    favBtn
  },
  props: {
    info: {
      required: true,
      default: () => {
        return {
          SourceId: 0,
          AuthorId: undefined,
          ParentId: undefined,
          isFav: false,
          name: "",
          commentType: undefined
        };
      }
    },
    commentsCount: {
      type: Number,
      default: 0
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      this.localActive = val;
      this.placeHolder = `@${this.info.name}：`;
    }
  },
  created() {
    EventBus.setGoodFunc(this.handleBusGetGoodStutas);
  },
  data() {
    return {
      maxlength: 300,
      maxImag: 6,
      localActive: this.isActive,
      clearUploadList: true,
      isGood: false,
      placeHolder: '说点什么...',
      form: {
        AppId: 1,
        Module: this.info.commentType,
        SourceId: "",
        ParentId: null,
        Content: "",
        ImgList: [],
        Avatar: this.$mdUtils.getUserInfo("Avatar"),
        UserName: this.$mdUtils.getUserInfo("NickName")
        // AuthorId: this.$mdUtils.getUserInfo('Id')
      }
    };
  },
  methods: {
    handleOpenComment() {
      this.info.ParentId = undefined;
      this.placeHolder = '说点什么...';
      this.localActive = true;
    },
    handleClose() {
      this.localActive = false;
      this.$emit("input", false);
    },
    handleUpImg(file) {
      let path = file.baseUrl;
      this.form.ImgList.push(path);
      if (this.form.ImgList.length == this.maxImag) {
        this.clearUploadList = false
      }
    },
    submit() {
      if (!this.form.Content) {
        return this.$tips.error("请输入内容");
      }
      let _form = JSON.parse(JSON.stringify(this.form))
      if (this.placeHolder !== '说点什么...') {
        _form.Content = this.placeHolder + _form.Content
      }
      let reqMsg = Object.assign({}, _form, this.info);
      this.$api(Comment.saveComment, reqMsg).then(() => {
        this.clear();
        this.$emit("onSuccess");
      });
    },
    clear() {
      this.form.Content = "";
      this.form.ImgList = [];
      this.clearUploadList = false;
      this.$nextTick(() => {
        this.clearUploadList = true;
        this.localActive = false;
      });
    },
    handleBusGetGoodStutas(val) {
      this.isGood = val;
    },
    handleGoodSuccess(val) {
      EventBus.chooseGoodFunc(val);
    },
    goComment() {
      document.getElementById("aritcle-comment").scrollIntoView();
    },
    deleteCommentImg(item) {
      let idx = this.form.ImgList.findIndex(i => i === item)
      this.form.ImgList.splice(idx, 1)
      if (this.form.ImgList.length < this.maxImag) {
        this.clearUploadList = true
      }
    }
  }
};
</script>

<style lang="scss">
.send-comment {
  .upload-btn {
    display: block;
    font-size: 22px;
    color: #aeaeae;
    height: 32px;
  }
}
</style>

<style lang='scss' scoped>
.stay-position {
  height: 56px;
  width: 100%;
}
.send-comment,
.send-comment-bar {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
}
.send-comment {
  display: flex;
  flex-direction: column;
  height: 100%;

  .shadow-box {
    flex: 1;
    background: rgba(0, 0, 0, 0.3);
  }
  .content-box {
    padding: 15px 20px;
    background: #fff;
  }
  .control-box {
    line-height: 54px;
    background: #fff;
  }

  .content-input-box {
    min-height: 60px;
    background: #f9f9f9;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    overflow: hidden;
  }
  .comment-img-list {
    display: flex;
    padding: 12px;
    margin-right: -14px;

    .comment-img {
      position: relative;
      width: 40px;
      height: 40px;
      margin-right: 14px;

      img {
        width: inherit;
        height: inherit;
      }
    }
    .delete-comment-img-btn {
      position: absolute;
      top: -4px;
      right: -4px;
      width: 14px;
      height: 14px;
      background: #666666;
      color: #fff;
      line-height: 14px;
      text-align: center;
      border-radius: 50%;
      .icon-quxiao {
        font-size: 12px;
        top: -1px;
        position: relative;
      }
    }
  }
  .content-input {
    padding: 4px 12px;
    background: #f9f9f9;
  }
  .img-box {
    padding-top: 20px;
    .upload-btn {
      width: 60px;
      height: 60px;
      line-height: 60px;
      border: 1px solid $gray;
      font-weight: blod;
      font-size: 14px;
      text-align: center;

      img {
        width: inherit;
        height: inherit;
      }
    }
  }
  .max-count {
    margin-right: 16px;
  }
}
.send-comment-bar {
  padding: 12px 0;
  border-top: 1px solid $border-color;
  border-bottom: 1px solid $border-color;
  background: #fff;

  .show-comment-btn {
    background: $gray;
    color: $gray-deep;
    border-radius: 100px;
    line-height: 30px;
    padding-left: 14px;
  }
  .control-box {
    margin-left: 28px;
    width: 130px;

    .icon-btn {
      font-size: 20px;

      .good-btn-icon {
        font-size: 20px;
      }
    }
  }
}
</style>